import { BugReportDump, EndEncounterDump, InitEncounterDump, RetrospectiveDump, UpdateEncounterDump, } from './bucket-dump-types.js';
// Event type constants
export const OrderEventType = 'order-event';
export const BugReportEventType = 'bug-report-event';
export const PathwayEventType = 'pathway-event';
export const FindingEventType = 'finding-event';
export const SnapshotEventType = 'snapshot-event';
export const EndEncounterEventType = 'end-encounter-event';
export const InitEncounterEventType = 'init-encounter-event';
export const UpdateEncounterEventType = 'update-encounter-event';
export const BugReportEventFileNames = [
    'findings_dump.json',
    'bug_report_dump.csv',
    'translated_encounter_data.xlsx',
];
export const DataTypeLabels = {
    [EndEncounterDump]: 'End encounter',
    [BugReportDump]: 'Bug report',
    [RetrospectiveDump]: 'Retrospective Dump',
    [InitEncounterDump]: 'Init encounter',
    [UpdateEncounterDump]: 'Update encounter'
};
export const EncounterEventTypes = [
    UpdateEncounterEventType,
    EndEncounterEventType,
    InitEncounterEventType,
    OrderEventType,
    BugReportEventType,
    PathwayEventType,
    FindingEventType,
    SnapshotEventType,
];
export const EncounterEventTypeLabels = {
    [UpdateEncounterEventType]: 'Encounter Updated',
    [EndEncounterEventType]: 'Encounter Ended',
    [InitEncounterEventType]: 'Init Encounter',
    [OrderEventType]: 'Order',
    [BugReportEventType]: 'Bug Report',
    [PathwayEventType]: 'Pathway',
    [FindingEventType]: 'Finding',
    [SnapshotEventType]: 'Snapshot',
};
export function getEncounterEventTypeLabel(eventType) {
    return EncounterEventTypeLabels[eventType] ?? eventType;
}
//# sourceMappingURL=types.js.map